/**
 * GET api/vpservice/equipmentBillingTemplates?jbCo=&template=
 * One sparta_BillingEquipTemplate row: an equipment BILL (charge-out) rate on
 * a bJBTM rate sheet, keyed by the same Template name as the labor rates
 * (29990). RateOpt 'R' is the standard rate; restrictByEquip / restrictByRevCode
 * ('Y') rows target a specific unit or revenue code rather than the category.
 * Rate is a decimal on the wire (C# decimal); the restrict flags are Y/N
 * strings, not booleans.
 *
 * Extracted from operations-management to this shared DTO lib for WI 32010 so
 * Resource Allocation can source its equipment picker from the same rate-sheet
 * rows the Estimate Builder uses (RA cannot import operations-management src).
 * Move is import-paths-only; the shape is unchanged from 29990/32009.
 */
export interface EquipmentBillingTemplateDto {
  jbCo: number | null;
  template: string | null;
  emCo: number | null;
  equipCategory: string | null;
  equipCategoryDesc: string | null;
  seq: number | null;
  restrictByEquip: string | null;
  restrictByRevCode: string | null;
  emGroup: number | null;
  revCode: string | null;
  rateOpt: string | null;
  rate: number | null;
  notes: string | null;
  equipment: string | null;
  /** Joined from sparta_EMEM.Description (EMCo + Equipment). Null when the sheet row has no unit or the master has no match. */
  equipmentDescription?: string | null;
}
